import React from "react";
import styled from "styled-components";
import { ProductCardType } from "../../../../hooks/api/queries/useProducts";
import { DesktopOnly } from "../../../layout/nav/DesktopNavbar";
import { ProductCard } from "../../category/ProductCard";

interface Props {
  items: ProductCardType[];
}

export const HomeDesktopProducts = ({ items }: Props) => {
  return (
    <DesktopOnly>
      <Wrapper>
        {items.map((item, key) => (
          <React.Fragment key={key}>
            <ProductCard product={item} />
          </React.Fragment>
        ))}
      </Wrapper>
    </DesktopOnly>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
`;
